export const FeedbackQuestions = {
  eventRating: 'How would you rank this Jam?',
  speakerRating: 'How would you rank the speaker?',
  challengeRating: 'How would you rate this challenge?',
  difficultyRating: 'How difficult was this challenge?',
  didYouLearn: 'Did you learn something new?'
};